<div class="h-full flex flex-col shadow-md hover:shadow-xl rounded-lg overflow-hidden bg-white dark:bg-black">

    <div class="relative overflow-hidden">
        <div class="bg-primary-500 dark:bg-petrol-200/[0.5]" [ngClass]="sizeClasses.header"></div>
    </div>

    <div class="h-full bg-gray-10 dark:bg-gray-900"
         [ngClass]="[sizeClasses.padding,sizeClasses.text,'dark:text-white dark:fill-white']">

        <ng-container 
            [ngTemplateOutlet]="corpContent"
            [ngTemplateOutletContext]="corpContext">
        </ng-container>

    </div>

</div>



